import React from 'react';
import intl from 'react-intl-universal';
import ExportButton from 'components/Common/ExportButton';
import ToolBarButton from 'components/Common/ToolbarButton';
import { Query } from 'react-apollo';
import countUsersQuery from 'queries/users/countUsersQuery.gql';
import _get from 'lodash/get';

interface Props {
  handleExportData: () => void;
  hasSelected: boolean;
  isExporting: boolean;
  onDeleteUsersClick: (arg: string[]) => void;
  onInviteUserClick: () => void;
  selectionArray: string[];
  usersTotal: number;
}

const UsersHeaderToolbar = ({
                              handleExportData,
                              hasSelected,
                              isExporting,
                              onDeleteUsersClick,
                              onInviteUserClick,
                              selectionArray,
                              usersTotal,
                            }: Props) => {

  const now = new Date();
  const queryVariables = {
    dateStart: now.toISOString().split('T')[0],
    dateEnd: now.toISOString().split('T')[0]
  };

  return (
    <div className="toolbar" data-test="toolbar">
      <div>
        <ExportButton
          disabled={false}
          isExporting={isExporting}
          onExportClick={handleExportData}
        />
        <ToolBarButton
          clickHandler={onInviteUserClick}
          isEnabled={true}
          disabledTooltipText={intl.get('tooltipMaxUsers')}
          label={intl.get('usersButtonLabelInvite')}
        />
        <ToolBarButton
          clickHandler={() => onDeleteUsersClick(selectionArray)}
          disabledTooltipText={intl.get('tooltipNoneSelectedUsers')}
          isEnabled={hasSelected}
          label={intl.get('usersButtonLabelDelete')}
          tooltipIsOnRight={true}
        />
      </div>
    </div>
  );
};

export default UsersHeaderToolbar;
